import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { environment } from '../environments/environment';
import { SharedService } from './shared.service';

@Injectable()
export class AppGuard implements CanActivate {
  constructor(private router: Router, private sharedService: SharedService) {}

  canActivate() {
    const showCart = this.sharedService.getSiteConfig().showCartPage;
    if (showCart) {
      return true;
    } else {
      this.router.navigate(['/landing']);
    }
    return false;
  }
}
